import apiInstance from './api';

const articleOfferApi = apiInstance.injectEndpoints({
  endpoints: (build) => ({
    getArticleOfferProcess: build.query({
      query: (id) => `/article_offers/${id}/ou_process_tracks`,
      transformResponse: (response) => response['hydra:member'],
      providesTags: ['ArticleOffersProcess'],
    }),
    getOffers: build.query({
      query: () => '/article_offers',
      providesTags: ['ArticleOffers'],
    }),
    getAuthorOffers: build.query({
      query: (authorId) => ({
        url: '/article_offers',
        params: { 'authors.author.id': authorId, pagination: false },
      }),
      transformResponse: (response) => response['hydra:member'],
      providesTags: ['ArticleOffers'],
    }),
    getGroupOffers: build.query({
      query: (params) => ({
        url: '/article_offers/all',
        params,
      }),
      transformResponse: (response) => response['hydra:member'],
      providesTags: ['ArticleOffers'],
    }),
    getGroupOffersInfinite: build.infiniteQuery({
      infiniteQueryOptions: {
        initialPageParam: 1,
        getNextPageParam: (lastPage, allPages, lastPageParam) =>
          lastPage['hydra:member'].length > 0 ? lastPageParam + 1 : undefined,
      },
      query({ queryArg, pageParam }) {
        const { title, isExcludeGrouped } = queryArg ?? {};
        return {
          url: '/article_offers/all',
          params: {
            page: pageParam,
            itemsPerPage: 20,
            ...(title && { title }),
            ...(isExcludeGrouped && { isExcludeGrouped }),
          },
        };
      },
      providesTags: ['ArticleOffers'],
    }),
    getOffer: build.query({
      query: (id) => `/article_offers/${id}`,
      providesTags: ['ArticleOfferDetail'],
    }),
    updataOfferTitle: build.mutation({
      query: ({ id, body }) => ({
        url: `/article_offers/${id}/title`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['ArticleOffers', 'ArticleOffersProcess', 'ArticleOfferDetail', 'AuthorArticles'],
    }),
    sendDecision: build.mutation({
      query: ({ id, committee, body }) => ({
        url: `/article_offers/decision/${committee}/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['ArticleOffers', 'ArticleOffersProcess', 'ArticleOfferDetail', 'AuthorArticles', 'ActivitiesList', 'Activities'],
    }),
    getArticleChains: build.query({
      query: (id) => `/article_offers/${id}/chains`,
      providesTags: ['ArticleChains'],
    }),
    sendArticleProcess: build.mutation({
      query: ({ id, body }) => ({
        url: `/article_offers/${id}/process/send_article/author`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['ArticleOffers', 'ArticleOffersProcess', 'ArticleOfferDetail', 'AuthorArticles', 'ActivitiesList'],
    }),
    sendCommitteeDecision: build.mutation({
      query: ({ id, body }) => ({
        url: `/article_offers/${id}/process/send_article/committee`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['ArticleOffers', 'ArticleOffersProcess', 'ArticleOfferDetail', 'AuthorArticles'],
    }),
    changeDeadline: build.mutation({
      query: ({ id, body }) => ({
        url: `/article_offers/deadlines/${id}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ArticleOffers', 'ArticleOffersProcess', 'ArticleOfferDetail', 'AuthorArticles'],
    }),
    changeSupervisor: build.mutation({
      query: ({ id, body }) => ({
        url: `article_offers/${id}/supervisor`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['ArticleOffers', 'ArticleOffersProcess', 'ArticleOfferDetail', 'AuthorArticles'],
    }),
    getArticleOfferGuides: build.query({
      query: (id) => `article_offers/${id}/guides`,
      providesTags: ['ArticleOfferGuides'],
      transformResponse: (response) => response['hydra:member'],
    }),
    downloadArticleOfferContentTemplate: build.query({
      query: ({ id, type }) => ({
        url: `article_offers/${id}/template/${type}`,
        responseType: 'blob',
        responseHandler: (response) => response.blob(),
      }),
      transformResponse: (response, meta) => {
        const fileName = meta.response.headers.get('content-disposition');
        return {
          data: response,
          fileName: fileName.split('filename=')[1],
        };
      },
      providesTags: ['ArticleOfferContentTemplate'],
    }),
  }),
  overrideExisting: true,
});

export default articleOfferApi;
